module.exports = __webpack_public_path__ + "static/media/blue_sky.493b1bdb.webp";